<template>
  <van-popup v-model="show" round position="bottom" :style="{ height: '85%' }" get-container="#app" lock-scroll>
    <div class="popup-div" @touchmove.stop>
      <div class="tetle">
        <span>提示</span>
        <img src="@/assets/close.png" alt class="close_img" @click="closeCodeModal"/>
      </div>
      <div class="full-comment">
        <div class="" style="height:100%">
          <div class="tips">
            <div class="tips-tetel-one">{{type == 'code' ?'本订单有关联赠品订单未发货，是否合并生成?':'本订单有关联赠品订单未发货，是否使用同一快递单号一起提交发货？'}}</div>
          </div>
          <div class="select">请选择</div>
      
          <div class="data" scroll-y="scroll">
            <!--  -->
            <div class="data-line"  v-for="item,index in giftList" :key="index"  @click.stop="onRadioType(index)">
              <div class="icon">
             
                <img :src="item.type === 2 ? $theme.assist_icon_radio_default : item.type === 1 ? $theme.assist_icon_radio_default_unselect : $theme.assist_icon_radio_disable" mode="widthFix"/> <!-- : skinOigInfo.u_assist_icon_radio_none -->
              </div>
              <div class="gift_list" :class="item.type === 2 ?'boxSelect':'boxNoSelect'">
                <div class="list_aggre"  v-for="_item,_index in item.orderItemList" :key="_index">
                  <img class="image"  :src="_item.skuImageKey"/>
                  <div class="content">
                    <div class="name">{{_item.itemName}}</div>
                    <div class="content-sku">数量{{_item.count}}件;{{_item.attributeValues}}</div>
                    <div class="full_tips">赠品</div>
                  </div>
                </div>
                <div class="order_info">
                  <div class="order_line">
                    <span class="text">赠品订单编号:</span>
                    <div class="order_right">
                      <span class="orderNo">{{item.subOrderCode}}</span>
                      <span class="btn" @click.stop="copyFun(item.subOrderCode)">复制</span>
                    </div>
                  </div>
                  <div class="order_line">
                    <span class="text">订单状态:</span>
                    <div class="order_right">
                      <span class="orderNo">{{item.orderStatusDesc}}</span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="full-btn" v-if="type == 'code'">
        <div class="cancel" @click="onNoMerge">不合并，继续生成</div>
        <div class="sumbtn" :style="{}" @click="mergeDeliver">合并生成</div>
      </div>
      <div class="full-btn" v-else>
        <div class="cancel" @click="shipThisTogether">仅本单发货</div>
        <div class="sumbtn" @click="shipTogether">合并发货</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
const CHECK = {
    uncheck: 1,   // 未选中 
    checked: 2,   // 选中
    disabled: 3   //  置灰不可选 
}
import { Toast } from "vant";
import Util from "@/utils/common";
export default {
  name: "",
  props: {},
  data(){
    return{
      show:false,
      type:'',
      giftList:[],
      subOrderId:'',  // 商品的子订单
      // formatType: {
      //   WAIT_SEND: "待发货",
      //   IN_STOCK: "备货中",
      //   WAIT_RECEIVING: "待收货",
      //   WAIT_PAY: "待付款",
      //   CANCEL_ADMIN: "已取消",
      //   CANCEL_TIMEOUT: "超时关闭",
      //   COMPLETED: "已完成",
      //   CANCEL_USER: "已取消",
      //   AFTER_ING: "售后处理中"
      // }
    };
    
    
  },
  methods:{
    closeCodeModal(){
      this.show = !this.show;
    },
    popupShow(type,data,subOrderId){
      //  传入进来的赠品列表
      let giftList = data;
      let subOrderIdVO = [];
      this.subOrderId = subOrderId;
      giftList.forEach(item=>{
        if(item.canChoose){
          item.type = CHECK.checked;
          subOrderIdVO.push(item.subOrderId);
        }else{
          item.type = CHECK.disabled;
        }
      })
      this.subOrderIdVO = subOrderIdVO;
      this.giftList = giftList;
      this.show = true;
      this.type = type
    },
    // 点击选中
    onRadioType(index){
      let giftList =JSON.parse(JSON.stringify(this.giftList)) ;
      let subOrderIdVO = [];
      if(giftList[index].type == CHECK.disabled){
        return
      }else{
        giftList[index].type =  giftList[index].type == CHECK.uncheck ? CHECK.checked : CHECK.uncheck;
        giftList.forEach(item=>{
          if(item.canChoose && item.type == CHECK.checked){
            subOrderIdVO.push(item.subOrderId);
          }
        })
      }
      this.giftList = giftList;
      this.subOrderIdVO = [...new Set(subOrderIdVO)];
      console.log('this.subOrderIdVO',this.subOrderIdVO)
    },
    // 不合并继续生成 (点击快递码)
    onNoMerge(){
      this.subOrderIdVO = [];
      this.show = false;
      this.$emit('onNoMerge');
    },
    mergeDeliver(){
      if(this.subOrderIdVO.length > 0){
        this.$emit('mergeDeliver',[...this.subOrderIdVO, parseInt(this.subOrderId)]);
        this.show = false;
      }else{
        return Toast("请选择赠品订单");
      }
    },
    // 一起发货
    shipTogether(){
      if(this.subOrderIdVO.length > 0){
        console.log('aadaSDSAdsadassd',[...this.subOrderIdVO, parseInt(this.subOrderId)])
        this.$emit('shipTogether',[...this.subOrderIdVO, parseInt(this.subOrderId)]);
        this.show = false;
      }else{
        return Toast("请选择赠品订单");
      }
    },
    // 本单发货
    shipThisTogether(){
      this.subOrderIdVO = [];
      this.show = false;
      this.$emit('shipThisTogether');
    },
    copyFun(code) {
      Util.copyText(code);
    },





  }
}
</script>

<style scoped lang="less">
.popup-div{
  height: 100%;
  position: relative;
  .tetle{
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    font-size:36px;
    font-weight: 600;
    color:#3B3A38;
    text-align: center;
    padding: 38px 0;
    .close_img {
      width: 60px;
      height: 60px;
      object-fit: cover;
      position: absolute;
      top: 20px;
      right: 20px;
    }
  }
  .full-comment{
    padding: 100px 24px 10px;
    height: calc(100% - 240px);

    .tips{
      background: #FEF6F0;
      border-radius: 20px;
      padding: 24px;
      .tips-tetel{
        font-weight: 500;
        color: #F08E3C;
        font-size: 26px;
      }
      .tips-tetel-one{
        color: #F08E3C;
        font-size: 24px;
        line-height: 35px;
      }
    }
    .select{
      color:#3B3A38;
      font-size: 28px;
      padding: 24px 0 0;
    }
  }
  .full-btn{
    display: flex;
    width: 100%;
    position: absolute;
    bottom: 30px;
    left: 0;
    align-items: center;
    margin-top: 27px;
    div{
      width:340px;
      height: 80px;
      line-height: 80px;
      text-align: center;
      border-radius: 40px;
      font-size: 32px;
    }
    .cancel{
      border: 2px solid #E1E1E1;
      border-color :#E1E1E1;
      background-color: #fff;
      color: #3B3A38;
      margin-right: 24px;
      margin-left: 24px;
    }
    .sumbtn{
      background: var(--epButtonColor);
      border-color: var(--epButtonColor);
      color: var(--epTextColor);
    }
  }
}


.data{
  height: calc(100% - 180px);
  overflow: auto;
  padding: 0px 0px 24px;
}

.data-line{
  display: flex;
  align-items: center;
  // padding:24px 12px;
  // box-shadow: 0px 2px 24px 0px rgba(216,220,230,0.5);
  border-radius: 16px;
  background: #FFFFFF;
  margin-top: 16px;
  .icon {
    width: 48px;
      height: 48px;
      display: contents;
      img{
      width: 48px;
      height: 48px;
  }
  }
  
  .boxNoSelect{
    border: 1px solid #fff;
  }
  .boxSelect{
   border: 1px solid #FFD102;
  }
  .gift_list{
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    padding:24px 16px;
    margin-left: 16px;
    box-shadow: 0px 2px 24px 0px rgba(216,220,230,0.5);
    .list_aggre{
      display: flex;
      justify-content: center;
      padding: 10px;
        .image {
          width: 160px;
          height: 160px;
          border-radius: 10px !important;
          margin: 16px;
        }
        .content{
          flex: 1;
          margin-left:10px;
          padding-top: 16px;
        }
        .content .name{
          font-size:26px;
          color: #333333;
          padding-bottom: 16px;
        }
        .content .content-sku{
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 400px;
          height: 30px;
          border-radius: 20px;
          color:#999999 ;
          font-size: 22px;
        }

        .full_tips{
          font-size: 24px;
          color: #fff;
          background: #E15554;
          text-align: center;
          border-radius: 4px;
          width: 64px;
          margin-top: 16px;
        }

    }
    .order_info{
     
      font-size: 26px;
      border-top:1px solid #E1E1E1;
      margin: 0 16px;
      // padding-top: 20px;
      .order_line{
        padding-top: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .text{
          color: #808080;
        }
        .order_right{
          display: flex;
          align-items: center;
          .orderNo{
            color: #3B3A38;
            font-weight: 600;
          }
          .btn{
            background: #F2F2F2;
            border-radius: 17px;
            padding: 4px 12px;
            color: #3B3A38;
            text-align: center;
            margin-left: 10px;
            font-size:22px;
          }
        }

      }
    }
  }
}


</style>